import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Drawer } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { Accommodation } from "@ui/containers/event/home/Accommodation";
import { ImportantInfoForm } from "@ui/containers/event/home/ImportantInfo";
import { PersonalInfoForm } from "@ui/containers/event/home/PersonalInfo";
import { TransportSelection } from "@ui/containers/event/home/Transport";
import { getInvitationDatesForByInvitationIdWithPreAccDateAsync } from "@application/features/invitation/invitationThunk";
const RelationsDayForm = ({ open, onClose, selectedInvitation, invitationType, }) => {
    const { control, handleSubmit, setError, setValue, clearErrors, getValues, trigger, watch, reset, formState: { errors }, } = useForm();
    const { personalInfo } = useAppSelector((state) => state.person);
    const handleTransportChange = (id) => { };
    const handleImportantInfoChange = (newId) => { };
    const handleAccommodationChange = (id) => { };
    const dispatch = useAppDispatch();
    const eventType = invitationType === 2 ? "externals" : "directors";
    useEffect(() => {
        if (selectedInvitation?.id) {
            dispatch(getInvitationDatesForByInvitationIdWithPreAccDateAsync(selectedInvitation?.id));
        }
    }, [open]);
    return (_jsx(Drawer, { anchor: "right", open: open, onClose: onClose, sx: { width: 525 }, children: _jsxs(Box, { sx: {
                height: "calc(100dvh - 30px)",
                overflowY: "auto",
                width: 525,
                pb: 2,
                px: 2,
            }, children: [_jsx(PersonalInfoForm, { control: control, eventType: eventType, errors: errors, formMod: "view", personId: personalInfo?.id || "", setValue: setValue, setError: setError, clearErrors: clearErrors, invitationId: selectedInvitation?.id, userId: selectedInvitation?.userId, reset: reset }), _jsx(Accommodation, { control: control, errors: errors, formMod: "view", eventType: eventType, personId: personalInfo?.id, setValue: setValue, onAccommodationChange: handleAccommodationChange }), _jsx(TransportSelection, { control: control, errors: errors, formMod: "view", eventType: eventType, personId: personalInfo?.id, setValue: setValue, onTransportChange: handleTransportChange }), _jsx(ImportantInfoForm, { control: control, eventType: eventType, errors: errors, formMod: "view", personId: personalInfo?.id, setValue: setValue, onImportantInfoChange: handleImportantInfoChange })] }) }));
};
export default RelationsDayForm;
